import { ca } from '@cian/analytics';

export function trackAddNewBuildingCompareEvent() {
  return ca('eventSite', {
    name: 'oldevent',
    category: 'CompareJK',
    action: 'add_more',
    page: {
      siteType: 'mobile',
      pageType: 'ListingCompareJK',
      listingType: 'list',
    },
  });
}
